import { createContext } from "react";

export const JourneyContext = createContext();

export const initialJourneyState = {'journeyList':[], 'pagemeta':{}, 'activeJourney':null}